
import Vue, { PropType } from 'vue'
import { Tablet } from '@/models'

import TabletListHeader from './TabletListHeader.vue'
import TabletListItem from './TabletListItem.vue'

export default Vue.extend({
  name: 'TabletList',

  props: {
    tablets: Array as PropType<Array<Tablet>>,
  },

  components: {
    TabletListHeader,
    TabletListItem,
  },
})
